var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadphoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0176 24.276C36.4444 20.4948 32.7436 18 28.6 18C22.9756 18 18.4 22.5756 18.4 28.2C18.4 28.8612 18.4636 29.5164 18.5884 30.1596C16.972 31.398 16 33.3348 16 35.4C16 39.0384 18.6916 42 22 42H35.8C40.7632 42 44.8 37.9632 44.8 33C44.8 28.8396 41.9872 25.2768 38.0176 24.276ZM34.3516 32.7504L31.6 29.9988V37.1988H29.2V29.9988L26.4484 32.7504L24.7516 31.0536L28.7032 27.102C29.638 26.1672 31.162 26.1672 32.0968 27.102L36.0484 31.0536L34.3516 32.7504Z",
    fill: "#14232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadphoto);
export default __webpack_public_path__ + "static/media/uploadphoto.0a264a3c18690e4f548d6462308bbd79.svg";
export { ForwardRef as ReactComponent };